import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { getModulesPermissions } from '../../services/PermissionsService';

const useModulesPermissions = (
  serviceBaseUrl: string,
  ocpApimKey: string,
  moduleKeys: string[],
  permissionCategory: 'Functional' | 'LocalData' = 'Functional'
) => {
  const { data, isLoading } = useQuery(
    ['PERMISSIONS', permissionCategory, moduleKeys],
    async () =>
      getModulesPermissions(
        serviceBaseUrl,
        ocpApimKey,
        moduleKeys,
        permissionCategory
      ),
    {
      enabled: moduleKeys.length > 0,

      staleTime: Infinity,
      keepPreviousData: true,
    }
  );

  const grantedModulePermissionKeys = useCallback(
    (moduleKey: string) =>
      (data && data[moduleKey]?.map((d) => d.permission)) || [],
    [data]
  );

  const isGranted = useCallback(
    (moduleKey: string, permissionKey: string) =>
      grantedModulePermissionKeys(moduleKey).includes(permissionKey),
    [grantedModulePermissionKeys]
  );

  return {
    isGranted,
    isLoading,
    grantedModulePermissionKeys,
  };
};

export { useModulesPermissions };
